import { render, staticRenderFns } from "./RoomDetail.vue?vue&type=template&id=49d53c2e&scoped=true&"
import script from "./RoomDetail.vue?vue&type=script&lang=js&"
export * from "./RoomDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoomDetail.vue?vue&type=style&index=0&id=49d53c2e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d53c2e",
  null
  
)

export default component.exports